import { EndpointGroup } from 'modules/endpoints/types';

const getBeaconGroup = (group: EndpointGroup) => group.beacons?.[0];

const getOpnodeGroup = (group: EndpointGroup) => group.opnodes?.[0];

export const getConsensusGroup = (group: EndpointGroup) =>
  getBeaconGroup(group) || getOpnodeGroup(group);
